angular.module('impactx.catalog').directive('ixCatalogInformation', function ()
{
    return {
        scope: {
            catalog: "=",
            headerLabel: "=",
            priceGroupsLabel: "=",
            noReleaseMessage: "=",
            changeProtocol: "=",
            trns: "=",
            downloadChangeProtocol: "&"
        },
        restrict: 'E',
        templateUrl: 'modules/catalog/templates/cataloginformation.tmpl.html',
        transclude: true
    };
});